<template>
  <BaseForm :model="formData" @loading="handleLoading">
    <FormHeader :title="_e('header_title')" :back-url="_e('header_back_url')" :image="_e('header_image')"></FormHeader>

    <FormBody>
      <DropdownInput required v-model="model.assunto" class="col--wide col--md-6"
        :label="_e('contact_subject_label', 'Assunto')"
        :placeholder="_e('contact_subject_placeholder', 'Selecione')"
        :options="subjectOptions">
      </DropdownInput>

      <DropdownInput required v-model="model.setor" class="col--wide col--md-6"
        :label="_e('contact_setor_label', 'Setor')"
        :placeholder="_e('contact_setor_placeholder', 'Selecione')"
        :options="sectorOptions">
      </DropdownInput>

      <h3 class="form-sec-title col--wide">{{ _e('contact_basic_data', 'Dados Pessoais') }}</h3>

      <BasicInput type="text" required v-model="model.nome" class="col--wide"
        :label="_e('contact_name_label', 'Nome Completo')"
        :placeholder="_e('contact_name_placeholder', 'Ex.: Carlos Almeida')">
      </BasicInput>

      <BasicInput type="email" required v-model="model.email" class="col--wide col--md-6"
        :label="_e('contact_email_label', 'Email')"
        :placeholder="_e('contact_email_placeholder', 'Ex.: carlos@email.com')">
        <template #prefix>
          <Icons name="mail" />
        </template>
      </BasicInput>

      <BasicInput type="text" required v-model="model.telefone" class="col--wide col--md-6"
        :label="_e('contact_phone_label', 'Telefone')"
        :placeholder="_e('contact_phone_placeholder', '+55 (00) 00000-0000')"
        :mask="['(##) #####-####', '(##) ####-####']">
        <template #prefix>
          <Icons name="phone" />
        </template>
      </BasicInput>

      <TextareaInput v-model="model.mensagem" class="col--wide"
        :label="_e('contact_message_label', 'Mensagem (Opcional)')"
        :placeholder="_e('contact_message_placeholder', 'Digite aqui sua mensagem')">
      </TextareaInput>

      <div class="col--wide">
        <CheckInput :options="termsConditions" v-model="model.terms" :required="true"></CheckInput>
      </div>

      <div class="col--wide col--md-5 col--jss">
        <VueTurnstile :site-key="config.TURNSTILE_KEY" v-model="token" theme="light"></VueTurnstile>
      </div>

      <div class="col--wide col--md-7 col--md-jse col--asc">
        <SubmitButton :is-loading="isLoading">{{ _e('contact_submit', 'Enviar') }}</SubmitButton>
      </div>
    </FormBody>
  </BaseForm>
</template>

<script setup>
import { ref, computed, reactive } from 'vue';
import { _e } from '../helpers/l10n';
import config from '../helpers/config';

import VueTurnstile from 'vue-turnstile';

import BasicInput from '../components/form/inputs/BaseInput.vue';
import DropdownInput from '../components/form/inputs/DropdownInput.vue';
import TextareaInput from '../components/form/inputs/TextareaInput.vue';
import CheckInput from '../components/form/inputs/CheckInput.vue';
import BaseForm from '../components/form/BaseForm.vue';
import SubmitButton from '../components/form/SubmitButton.vue';
import Icons from '../components/icons/Icons.vue';
import FormHeader from '../components/sections/FormHeader.vue';
import FormBody from '../components/sections/FormBody.vue';


const termsConditions = _e('termos_condicoes');

const subjectOptions = _e('contact_subject_list');
const sectorOptions = _e('contact_sector_list');

const token = ref('');
const isLoading = ref(false);

const model = reactive({
  nome: '',
  email: '',
  telefone: '',
  assunto: '',
  setor: '',
  mensagem: '',
  terms: false,
});

function handleLoading(isFormLoading) {
  isLoading.value = isFormLoading;
}

const formData = computed(() => {
  const formData = new FormData();
    formData.append('nome', model.nome);
    formData.append('email', model.email);
    formData.append('telefone', model.telefone);
    formData.append('assunto', model.assunto);
    formData.append('setor', model.setor);
    formData.append('mensagem', model.mensagem);
    formData.append('terms', model.terms ? 1 : 0);
    formData.append('cf_token', token.value);

  return formData;
});
</script>
